import {electronicFormatIBAN, isValidIBAN} from 'ibantools';

/**
 * @param {string} inputValue The input value to be validated.
 * @param {string|undefined} errorMessage The custom error message to display, when invalid.
 * @param {object} vArgs The validator arguments
 * @param {any} context Additional context
 * @returns {boolean|string} Either a boolean, if valid, or the error message.
 */
export default function validate(inputValue, errorMessage, vArgs, context) {
  const errorMsg = errorMessage || `Not a valid IBAN`;

  const iban = electronicFormatIBAN(inputValue);
  if (!iban) return errorMsg;

  return !inputValue.length || isValidIBAN(iban) || errorMsg;
}
